module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/permissions/permissions-show/permissions-show.component.scss
// module id = ./src/app/views/setting/permissions/permissions-show/permissions-show.component.scss
// module chunks = main